import { GridItem, Tag, FormLabel, Box, Button as ButtonChakra, Grid, 
  InputGroup,InputLeftAddon,Stack,
        IconButton, Input, Select, Textarea, useDisclosure } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDestinos, createDestinos, updateNotes, deleteNotes } from "../redux/destinos/destino_actions";

import { FloatButton } from 'antd';


import { useMediaQuery } from "@chakra-ui/react"

import DataTable from 'react-data-table-component';

import { deleteDestinos, updateDestinos } from "../redux/destinos/destino_actions"

import { Table, Button, Icon } from "semantic-ui-react";

import { Wrap, WrapItem } from '@chakra-ui/react'
import { Center, Square, Circle } from '@chakra-ui/react'

import { Sketch } from "@uiw/react-color";
import Compact from '@uiw/react-color-compact';

import DestinoCard from "../components/Destinos/DestinoCard/DestinoCard";
import {toast, Toaster } from 'react-hot-toast';

import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
} from "@chakra-ui/react";

import { ChromePicker , SketchPicker } from 'react-color';

// import { ColorPicker, useColor } from "react-color-palette";
// import "react-color-palette/css";

export default function Destinospage()
{
    const dispatch = useDispatch()
    const {loading, error, datadestino} = useSelector((state)=>state.destinoReducer)
    const [destinos, setDestinos] = useState([])
    
    const { isOpen, onOpen, onClose } = useDisclosure()
    const modalEdit = useDisclosure()

    const initialRef = useRef(null)
    const finalRef = useRef(null)
    const [descripcion, setDescripcion] = useState("")
    
    const [web, setWeb] = useState("")

    const [tempDescripcion, setDescripcion2] = useState(descripcion)
    const [tempWeb, setWeb2] = useState(web)
    const [tempID,setId] = useState(); 

    const [hex, setHex] = useState("#ffffff");
    const [tempHex, setHex2] = useState(hex);
    
    // const [color, setColor] = useState("#fff");
    // const [tempColor, setColor2] = useState(color);


    useEffect(()=>{
        //console.log(" useEfect Destinopage");
        
        dispatch(getDestinos())
    }, [])

    useEffect(()=>{
        setDestinos(datadestino);        
        console.log(" Data Destinos 2 => ",datadestino);
        
    }, [datadestino])

    const createDestino = ()=>{
        setDescripcion('');
        setWeb('');
        dispatch(createDestinos({descripcion,hex,web}))
        onClose()
    }

    const updateDestino = ()=>{
      dispatch(updateDestinos(tempID, {descripcion: tempDescripcion, color: tempHex, web:tempWeb}))
      modalEdit.onClose()
    }

    const [isMobile] = useMediaQuery("(max-width: 768px)") 

    const columns = [
      {
        name: "Acciones",width:"100px",
        selector: (row) => {
          return (
            <Actions
              row={row}
              id={row.id}
              setId={setId}
              modalEdit={modalEdit}
              setDescripcion2={setDescripcion2}
              setWeb2={setWeb2}
              
            />
          );
        },
      },  
      {
        name: 'Descripción', selector: row => row.descripcion,
      },      
      {
        name: 'Página Web', selector: row => row.web,
      },            
    ];

    const paginationComponentOptions = {
      rowsPerPageText: 'Filas por página',
      rangeSeparatorText: 'de',
      selectAllRowsItem: true,
      selectAllRowsItemText: 'Todos',
    };     

    

    return (
      <>
      <FloatButton icon={<AddIcon fontSize={20} />} onClick={onOpen} type="primary"/>;
        <Box mt={20} padding={8}> Destinos

          <DataTable
            title="Destinos"
			      columns={columns}
			      data={datadestino}
            pagination
            paginationComponentOptions={paginationComponentOptions}
		      />



        <Grid gap={10} w={"100%"} margin={"auto"} gridTemplateColumns="repeat(4, 1fr)">
            {/* {destinos?.map((el)=><DestinoCard {...el}/>)} */}
        </Grid>

        <>
        {/*<IconButton boxShadow={"rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;"} position={"fixed"} w={"100px"} h={"100px"} bg={"#5b9cf2"} bottom={0} right={0} margin={16} icon={<AddIcon fontSize={30} />} 
        onClick={onOpen}></IconButton>*/}
         {/* Modal Insertar */}
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
            <ModalContent  maxW={isMobile ? "100%" : "40%"}>
            <ModalHeader>Crear nuevo destino {hex}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>  
                <Stack spacing={4}>
                      <InputGroup>
                          <InputLeftAddon width={150}>Descripción</InputLeftAddon>
                          <Input value={descripcion} placeholder="Introduce la descripción" onChange={(e)=>setDescripcion(e.target.value)}></Input>
                      </InputGroup>
                      <InputGroup>
                          <InputLeftAddon width={150}>Página Web</InputLeftAddon>
                          <Input value={web} placeholder="Introduce la página web" onChange={(e)=>setWeb(e.target.value)}></Input>
                      </InputGroup>                      
                      <InputGroup>
                        <InputLeftAddon width={150}>Color</InputLeftAddon>
                        
                        <Compact color={hex} onChange={(color) => {setHex(color.hex);}}/>


                      </InputGroup>

                </Stack>
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={createDestino}>              
                Crear
              </Button>
              <Button onClick={onClose}>Cancelar</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        </>
        {/* Modal Editor */}
        <>         
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          closeOnOverlayClick={false}
          isOpen={modalEdit.isOpen} onClose={modalEdit.onClose}
        >
          <ModalOverlay />
            <ModalContent  maxW={isMobile ? "100%" : "40%"}>
              <ModalHeader>Editar Destino</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Stack spacing={4}>
                      <InputGroup>
                          <InputLeftAddon width={150}>ID</InputLeftAddon>
                          <Input isDisabled value={tempID} onChange={(e)=>setId(e.target.value)}></Input>
                      </InputGroup>                  
                      <InputGroup>
                          <InputLeftAddon width={150}>Descripción</InputLeftAddon>
                          <Input value={tempDescripcion}m placeholder="Introduce la descripción" onChange={(e)=>setDescripcion2(e.target.value)}></Input>
                      </InputGroup>
                      <InputGroup>
                          <InputLeftAddon width={150}>Página Web</InputLeftAddon>
                          <Input value={tempWeb}m placeholder="Introduce la página web" onChange={(e)=>setWeb2(e.target.value)}></Input>
                      </InputGroup>                      
                      <InputGroup>
                        <InputLeftAddon width={150}>Color</InputLeftAddon>
                        <Compact color={tempHex} onChange={(color) => {setHex2(color.hex);}}/>
                      </InputGroup>
                </Stack>
              </ModalBody>
              <ModalFooter>
                <ButtonChakra olorScheme="blue" mr={3} onClick={updateDestino}> 
                  Guardar
                </ButtonChakra> 
                <ButtonChakra onClick={modalEdit.onClose}>Cerrar</ButtonChakra>
              </ModalFooter>              
            </ModalContent>

          </Modal>
        </>
        <Toaster />
    </Box>
    </>
    )
}

function Actions(props) {
  const { row, modalEdit,
        id, 
        setId,
        setDescripcion2,
        setWeb2,                
       } = props;

  return (
    <Table.Cell textAlign="right">
        <Icon name="pencil" onClick={() => {
                setId(id);
                setDescripcion2(row.descripcion);
                setWeb2(row.web);                
                modalEdit.onOpen();
          }}/> 
      
    </Table.Cell>
  );
}